import { cn } from '@/lib/utils'
import { SvgProps } from './@types'

export function Svg({ src, className, alt = 'icon' }: SvgProps) {
  return (
    <img
      src={src}
      alt={alt}
      className={cn(className, 'w-full h-full object-fill')}
    />
  )
}
